module.exports = __webpack_public_path__ + "static/media/awks.3c100441.webp";